import { useMemo } from "react"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import type { AppDispatch, RootState } from "./store"

export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const useLoading = () =>
  useAppSelector((state) => state.loader.loading || state.loader.forcedLoading)
export const useForcedTurnOff = () =>
  useAppSelector((state) => state.loader.forcedTurnOff)
export const useSnackbar = () =>
  useAppSelector((state) => state.snackbarItem.active)
export const useBackendError = () =>
  useAppSelector((state) => state.beError.hasError)
export const useCounter = () => useAppSelector((state) => state.counter)

export const useValueLists = () =>
  useAppSelector((state) => state.valueLists.valueLists)

export const useStatusFilter = () =>
  useAppSelector((state) => state.dashboardFilters.statusFilter)

export const useLoanCase = (caseId: string) =>
  useAppSelector((state) =>
    state.cases.list?.find((el) => el.caseId === caseId),
  )
export const useLoanCases = () => useAppSelector((state) => state.cases.list)
export const useSelectedLoanCase = () =>
  useAppSelector((state) => state.cases.selected)

export const useCaseEvents = () =>
  useAppSelector((state) => state.caseEvents.list)
export const useCaseEventsByCaseId = (caseId: string) => {
  const list = useCaseEvents()
  return useMemo(
    () => list?.filter((el) => el.caseId === caseId),
    [list, caseId],
  )
}

export const useOffers = () => useAppSelector((state) => state.offers.list)
export const useSelectedOffer = () =>
  useAppSelector((state) => state.offers.selected)

export const useOfferData = () =>
  useAppSelector((state) => state.offerData.loanCaseForOffer)

export const useProfiles = () =>
  useAppSelector((state) => state.profiles.profiles)
export const useSelectedProfileId = () =>
  useAppSelector((state) => state.selectedProfile.selectedProfileId)
export const useSelectedProfile = () =>
  useAppSelector((state) =>
    state.profiles.profiles?.find(
      (el) => el.id === state.selectedProfile?.selectedProfileId,
    ),
  )
export const useSelectedSapId = () =>
  useAppSelector((state) =>
    state.profiles.profiles?.find(
      (el) => el.id === state.selectedProfile?.selectedProfileId,
    ),
  )?.sapId

export const useNotification = (id: string) =>
  useAppSelector((state) =>
    state.notifications.notifications.find((n) => n.messageId === id),
  )
export const useNotifications = () =>
  useAppSelector((state) => state.notifications.notifications)

export const useBranch = () =>
  useAppSelector((state) => state.branches.selected)
export const useBranches = () => useAppSelector((state) => state.branches.list)
